// Import Vue
import Vue from 'vue';

const selectedMeasurement = () => {
  document.querySelectorAll('[data-selected-measurement]').forEach((el) => {
    new Vue({
      el: el,
      data () {
        return {
          selected: 'Volume'
        };
      },
      watch: {
        selected (value) {
          // Set local storage
          localStorage.measurement = value;
        }
      },
      mounted () {
        if (!('measurement' in localStorage)) {
          this.selected = 'Volume';
        } else {
          this.selected = localStorage.measurement;
        }
      }
    });
  });
};

export default selectedMeasurement;
